// Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AlertType } from '@uw/shared/models/alert.model';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'uw-alert',
    styleUrls: ['./alert.component.scss'],
    templateUrl: './alert.component.html',
    imports: [MatIconButton, MatIcon, TranslateModule]
})
export class AlertComponent implements OnInit {
  // Public properties
  @Input() type!: AlertType;
  @Input() duration = 0;
  @Input() showAlertIcon = true;
  @Input() showCloseButton = true;
  @Output() close = new EventEmitter<boolean>();
  alertShowing = true;

  alertTypeEnum = AlertType;

  ngOnInit() {
    if (this.duration === 0) {
      return;
    }

    setTimeout(() => {
      this.closeAlert();
    }, this.duration);
  }

  closeAlert() {
    this.close.emit();
  }
}
